import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { updateUser } from "../../features/userSlice/userSlice";
import { toast } from "react-toastify";
import Breadcrumbs from "../../Breadcrumbs";
import Select from "react-select";
import {
  fetchUserList,
  userRoleList,
} from "../../features/commonSlice/commonSlice";

const UpdateUserDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedData = location.state;

  const [errors, setErrors] = useState("");
  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");
  const [showToaster, setShowToaster] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [initialData, setInitialData] = useState(null);

  const [roleList, setRoleList] = useState([]);
  const [usersList, setUsersList] = useState({ data: [] });

  const {
    usersData,
    roleDataList,
    status: commonStatus,
  } = useSelector((state) => state.influencer);

  const [formData, setFormData] = useState({
    name: "",
    mobile_no: "",
    role: null,
    manager: null,
    credit_in: "0",
  });

  useEffect(() => {
    dispatch(fetchUserList());
    dispatch(userRoleList());
  }, []);

  useEffect(() => {
    if (commonStatus === "succeeded") {
      setUsersList(usersData);
    }
  }, [commonStatus, usersData]);

  useEffect(() => {
    setRoleList(roleDataList?.data);
  }, [roleDataList]);

  useEffect(() => {
    if (!selectedData) return;

    const selectedRole =
      roleList?.find(
        (role) => String(role?.value) === String(selectedData?.role_id)
      ) || null;

    const selectedManager =
      usersList?.data?.find(
        (user) => String(user?.value) === String(selectedData?.manager_id)
      ) || null;

    const data = {
      name: selectedData?.name || "",
      mobile_no: selectedData?.mobile_no || "",
      role: selectedRole,
      manager: selectedManager,
      credit_in: "0",
    };
    setFormData(data);
    setInitialData(data);
  }, [selectedData, roleList, usersList]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleReset = () => {
    if (initialData) {
      setFormData(initialData);
    }
  };

  const handleUpdate = async () => {
    try {
      setIsLoading(true);
      const payload = {
        user_id: selectedData.id || 0,
        name: formData.name,
        mobile_no: formData.mobile_no,
        role_id: String(formData?.role?.value),
        manager_id: formData?.manager?.value,
        credit_in: Number(formData.credit_in || 0),
      };
      await dispatch(updateUser(payload))
        .unwrap()
        .then((result) => {
          if (result.status) {
            setShowToaster(true);
            toast.success(result.message, {
              onClose: () => {
                setIsLoading(true);
                navigate("/registered-user-list");
                setFormData({
                  name: "",
                  mobile_no: "",
                  role_id: "",
                  manager_id: "",
                  credit_in: null,
                });
              },
            });
          } else {
            setIsLoading(false);
            setErrorData(result.form_err);
          }
        })
        .catch((err) => {
          setErrorData(err.form_err || []);
          toast.error(err.message);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsLoading(false); // ✅ ALWAYS reset
    }
  };

  const mapErrors = (errorData) => {
    const errorMap = {};
    errorData.forEach((error) => {
      if (!errorMap[error.param]) {
        // errorMap[error.param] = error.msg;
        const path = error.param.split(".").join("_");
        errorMap[path] = error.msg;
      }
    });
    return errorMap;
  };

  const handleBack = () => {
    navigate("/registered-user-list");
  };

  useEffect(() => {
    const errorsValue = mapErrors(errorData);
    setErrors(errorsValue);
  }, [errorData]);

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Update User Details </h4>

            {/* <div className="page-title-right">
              <Breadcrumbs />
            </div> */}
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="card shadow-sm col-8">
          {/* ✅ CARD HEADER */}
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Update User Details</h5>

            <Button variant="outline-secondary" size="sm" onClick={handleBack}>
              ← Back
            </Button>
          </div>

          {/* ✅ CARD BODY */}
          <div className="card-body">
            <div className="row">
              <div class="col-md-6 mb-3">
                <label className="form-label mb-2">Name</label>
                <input
                  type="text"
                  className="form-control pe-5"
                  name="name"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  autoComplete="off"
                />

                {errors.name && (
                  <div className="text-danger">{errors.name}</div>
                )}
              </div>
              <div class="col-md-6 mb-3">
                <label className="form-label mb-2">Mobile No</label>
                <input
                  type="text"
                  className="form-control pe-5"
                  name="mobile_no"
                  placeholder="Enter mobile no."
                  value={formData.mobile_no}
                  onChange={handleInputChange}
                  autoComplete="off"
                />

                {errors.mobile_no && (
                  <div className="text-danger">{errors.mobile_no}</div>
                )}
              </div>
              <div class="col-md-6 mb-3">
                <label htmlFor="role" className="form-label">
                  Select Role <span className="text-danger">*</span>
                </label>
                <Select
                  name="role"
                  options={roleList}
                  classNamePrefix="select"
                  value={formData.role}
                  onChange={(selected) => handleSelectChange("role", selected)}
                />
                <div className="text-danger">
                  {errors.role && <>{errors.role}</>}
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <label htmlFor="manager" className="form-label">
                  Select Manager{" "}
                </label>
                <Select
                  name="manager"
                  options={usersList?.data}
                  classNamePrefix="select"
                  value={formData.manager}
                  onChange={(selected) =>
                    handleSelectChange("manager", selected)
                  }
                />
                <div className="text-danger">
                  {errors.manager && <>{errors.manager}</>}
                </div>
              </div>
              <div class="col-md-12 mb-3">
                {(Number(selectedData.credit_out) > 0 ||
                  Number(selectedData.credit_in) > 0) && (
                  <label className="form-label">
                    <span className="me-2"> Available Credit :</span>{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {" "}
                      {selectedData.credit_out || 0} /{" "}
                      {selectedData.credit_in || 0}
                    </span>
                  </label>
                )}

                <p className="form-label">
                  <strong>Add Credit</strong>
                </p>
                <input
                  type="number"
                  className="form-control pe-5"
                  name="credit_in"
                  placeholder="Enter credit"
                  value={formData.credit_in}
                  onChange={handleInputChange}
                  autoComplete="off"
                />

                {errors.credit_in && (
                  <div className="text-danger">{errors.credit_in}</div>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Button variant="danger" className="me-2" onClick={handleReset}>
                Reset
              </Button>
              <Button
                variant="success"
                onClick={handleUpdate}
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                ) : (
                  "Update"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateUserDetails;
